import React from "react";
import { Link } from "react-router-dom";

// 👉 Assets
import lpEngelskirchen from "../assets/maerkte/bilder_resized/landpartie_Engelskirchen__Villa_Braunswerth.webp";
import krefelder_gartenwelt from "../assets/maerkte/bilder_resized/krefelder_Gartenwelt.webp";
import landpartie_Festung_Ehrenbreitstein from "../assets/maerkte/bilder_resized/landpartie_Festung_Ehrenbreitstein.webp";
import herbstfestival_schloss_eller from "../assets/maerkte/bilder_resized/herbstfestival_schloss_eller.webp";
import hp_burg_Namedy from "../assets/maerkte/bilder_resized/hp_burg_Namedy.webp";
import krefelder_Herbstzauber from "../assets/maerkte/bilder_resized/krefelder_Herbstzauber.webp";
import basar_der_kunsthandwerkermarkt_schloss_burg from "../assets/maerkte/bilder_resized/basar_der_kunsthandwerkermarkt_schloss_burg.webp";
import schlossweihnacht_schloss_dyck from "../assets/maerkte/bilder_resized/schlossweihnacht_schloss_dyck.webp";
import schlDyck from "../assets/maerkte/bilder_resized/schloss_Dyck.webp";
import lindlar from "../assets/maerkte/bilder_resized/vR_Freilichtmuseum_Lindlar.webp";
import backgroundImg from "../assets/home_maerkte.png";

import maerkteData from "./data/maerkte.json";

// Mappt die JSON-Keys auf die importierten Bilder
const imageMap = {
  lpEngelskirchen,
  krefelder_gartenwelt,
  landpartie_Festung_Ehrenbreitstein,
  schlDyck,
  herbstfestival_schloss_eller,
  hp_burg_Namedy,
  krefelder_Herbstzauber,
  basar_der_kunsthandwerkermarkt_schloss_burg,
  schlossweihnacht_schloss_dyck,
  lindlar,
};

function Hero() {
  return (
    <header
      className="hero"
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className="container hero__inner">
        <h1 className="text-align-center">Märkte</h1>
        <p className="lead">
          Jeder Markt besticht durch seine Einzigartigkeit und Individualität.
          In der Übersicht findest du alle Märkte an denen ich dieses Jahr teilnehme. Die Buttons führen dich direkt zu den Websites der Veranstalter. 
          Ich freue mich auf dich und deinen Besuch an meinem Stand!
        </p>
      </div>
    </header>
  );
}

function Maerkte() {
  // Daten kommen aus JSON; Bild wird aus imageMap oder direkt aus c.img geholt
  const cards = maerkteData;

  return (
    <main className="section section--page">
      <div className="container">
        <div className="cards cards--markets">
          {cards.map((c) => {
            const imgSrc = c.img ? c.img : imageMap[c.imgKey];
            return (
              <article className="card card--market" key={c.title}>
                <div
                  className="card__bg"
                  style={{ backgroundImage: `url(${imgSrc})` }}
                  aria-hidden="true"
                />
                <div className="card__content">
                  <div className="card__body">
                    <h3 className="card__title">{c.title}</h3>
                    <h4 className="card__subtitle">{c.date}</h4>
                    <p className="card__text">{c.text}</p>
                  </div>

                  {/* Externe Links besser als <Link> → neues Tab */}
                  <a
                    href={c.to}
                    className="btn card__btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {c.button_text}
                  </a>
                </div>
              </article>
            );
          })}
        </div>

        <div className="backlink" style={{ marginTop: 24 }}>
          <Link to="/">← Zurück zur Startseite</Link>
        </div>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <>
      <Hero />
      <Maerkte />
    </>
  );
}
